'use client';

import React from 'react';
import { BodyTextMediumD } from '@/shared/ui/typography2';
import { Container, WarningIcon } from './styles';
import { useGameAccessCheck } from '@/shared/hooks/useGameAccessCheck';
import { useScopedI18n } from '@locales/client';
import type { GameCatalogItem } from '@/entities/game/model/types';

interface BonusNotWageringInfoProps {
  isHovered?: boolean;
  game?: GameCatalogItem | null;
}

export const BonusNotWageringInfo: React.FC<BonusNotWageringInfoProps> = ({
  isHovered = false,
  game,
}) => {
  const accessHelpers = useGameAccessCheck();
  const canOpenGame = accessHelpers?.isDisabled(game);
  const t = useScopedI18n('');

  return (
    <Container $isView={canOpenGame}>
      <WarningIcon
        src={
          isHovered
            ? '/images/icons/warning-icon-white-bonus.svg'
            : '/images/icons/warning-icon-bonus.svg'
        }
      />
      <BodyTextMediumD>
        {t('bonus.bonus_loss_modal.no_play_bonus')}
      </BodyTextMediumD>
    </Container>
  );
};
